// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PFFu9a1hzMTdOdFHxh50Fg\\=\\={z-index:2;height:100vh}._3bdD-5KdCDUkAgyuZWptbw\\=\\={justify-content:center;margin:auto}", "",{"version":3,"sources":["webpack://./src/features/dashboard/components/WidgetConfigurationSidebar.module.scss"],"names":[],"mappings":"AAAA,4BACE,SAAA,CACA,YAAA,CAGF,6BACE,sBAAA,CACA,WAAA","sourcesContent":[".sidebar {\n  z-index: 2;\n  height: 100vh;\n}\n\n.loadingSpinner {\n  justify-content: center;\n  margin: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": "PFFu9a1hzMTdOdFHxh50Fg==",
	"loadingSpinner": "_3bdD-5KdCDUkAgyuZWptbw=="
};
export default ___CSS_LOADER_EXPORT___;
